exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-container[data-v-3172e8b1]{margin:0 auto;width:40px;height:40px}.title[data-v-3172e8b1]{display:block;font-size:24px;line-height:46px}.memo[data-v-3172e8b1]{display:block;color:#999;font-size:14px;line-height:22px}.divider[data-v-3172e8b1]{margin:70px 0}", ""]);

// exports
